var _circle, _path, _line, _line2, _line3, _line4, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdentityicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 40,
    viewBox: "0 0 37 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.9606,
    cy: 17.3805,
    r: 3.57,
    stroke: "#CECECE",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59961 14.14C4.85961 5.86009 11.8796 0.999997 20.1596 1C28.4396 1 35.9996 8.37988 35.9996 16.66C35.9996 24.9401 30.0596 29.62 30.0596 29.62V30.7V39.3401",
    stroke: "#CECECE",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.99023,
    y1: 13.7803,
    x2: 3.99023,
    y2: 19.5403,
    stroke: "#CECECE",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.91804,
    y1: 19.5008,
    x2: 0.678038,
    y2: 26.3408,
    stroke: "#CECECE",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.385872,
    y1: 25.3774,
    x2: 3.98587,
    y2: 27.5374,
    stroke: "#CECECE",
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 3.99023,
    y1: 27.46,
    x2: 3.99023,
    y2: 36.46,
    stroke: "#CECECE",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59961 36.1002L5.21961 37.9002C5.21961 37.9002 8.99961 37.9002 15.1196 37.9002C21.2396 37.9002 21.9596 30.7002 21.9596 30.7002",
    stroke: "#CECECE",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9609 30.7005V21.5205",
    stroke: "#CECECE",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.38 11.0801C14.9393 12.1601 13.4995 14.5001 13.5 17.0201C13.5005 19.5401 14.2946 21.5969 16.38 23.3201",
    stroke: "#00D7FB",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7196 10.9004C29.1603 11.9804 30.6001 14.3204 30.5996 16.8404C30.5992 19.3604 29.805 21.4173 27.7196 23.1404",
    stroke: "#00D7FB",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentityicon);
export default __webpack_public_path__ + "static/media/identity icon.f0821f3da0d1494b24c420b292d1c3f1.svg";
export { ForwardRef as ReactComponent };